<template>
	<v-container style=" margin-top: 10px;">
		<p>
			The variable is scored on a scale from 0 to 100, with 100 representing the
			highest level of rights and freedoms. This map represents these scores,
			highlighting the state of human rights of the countries of <strong>your connections.</strong> It captures the extent to which people are free from
			government torture, political killings, and forced labor. It also
			evaluates the extent to which individuals can exercise their property
			rights and enjoy fundamental freedoms, including the freedom to move,
			practice religion, express opinions, and associate with others.
		</p>
		<p style="font-weight: bold;">
			Source: V-Dem (2026) – processed by Our World in Data.
		</p>
		<v-card class="connection-map-card">
			<div id="response-container" class="connection-map-frame"></div>
		</v-card>
	</v-container>
</template>

<script>
import SupplierAPI from "../../api/csr/supplier"
import { mapAPI } from "../../api/csr/map"
import LoadingState from "../../consts/LoadingState"
import iso3166 from "iso-3166-1"
import { mountConnectionMap } from "../../utils/mountConnectionMap"

export default {
	data() {
		return {}
	},
	mounted() {
		this.loadItems()
		this.loadScript("https://static.dwcdn.net/js/events.js", () => {
			if (window.datawrapper) {
				window.datawrapper.on("region.click", (event) => {
					console.log(event.chartId, event.data)
				})
			}
		})
	},
	methods: {
		loadScript(src, callback) {
			const script = document.createElement("script")
			script.src = src
			script.onload = callback
			document.head.appendChild(script)
		},
		async updateAndPublishChart(countryArray, companyArray, scoresArray) {
			const codesArray = countryArray.map((country) => {
				const countryData = iso3166.whereCountry(country)
				return countryData ? countryData.alpha3 : "Unknown"
			})

			const cumulativeScores = {}
			const uniqueCountryArray = []
			const uniqueCodesArray = []
			const cumulativeScoresArray = []
			const breakdownArray = []

			for (let i = 0; i < countryArray.length; i++) {
				const country = countryArray[i]
				const score = scoresArray[i]
				const company = companyArray[i]
				const code = codesArray[i]

				if (!cumulativeScores[country]) {
					cumulativeScores[country] = {
						total: 0,
						count: 0,
						breakdown: [],
						code: code,
					}
					uniqueCountryArray.push(country)
					uniqueCodesArray.push(code)
				}

				cumulativeScores[country].total += score
				cumulativeScores[country].count += 1
				cumulativeScores[country].breakdown.push(`${company} - ${score} %`)
			}

			for (const country of uniqueCountryArray) {
				const averageScore =
					cumulativeScores[country].total / cumulativeScores[country].count
				cumulativeScoresArray.push(averageScore)
				breakdownArray.push(cumulativeScores[country].breakdown.join("<br>"))
			}

			console.log("Unique Country Array:", uniqueCountryArray)
			console.log("Unique Codes Array:", uniqueCodesArray)
			console.log(
				"Cumulative Scores Array (Average Scores):",
				cumulativeScoresArray
			)
			console.log("Breakdown Array:", breakdownArray)
			try {
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_START_LOADING,
					null,
					{ root: true }
				)
				await mapAPI.updateChart(
					uniqueCountryArray,
					uniqueCodesArray,
					cumulativeScoresArray,
					breakdownArray,
					"n9ohU"
				)

				const embedCode = await mapAPI.publishMap("n9ohU")
				mountConnectionMap(document.getElementById("response-container"), embedCode)
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_END_LOADING,
					null,
					{ root: true }
				)
			} catch (error) {
				document.getElementById(
					"response-container"
				).innerHTML = `<p>Error: ${error.message}</p>`
				console.error("Fetch error:", error)
				this.$store.dispatch(
					"loading/" + LoadingState.ACTION_SET_ERROR,
					error,
					{ root: true }
				)
			}
		},
		loadItems() {
			this.$store.dispatch(
				"loading/" + LoadingState.ACTION_START_LOADING,
				null,
				{ root: true }
			)
			SupplierAPI.getSuppliers()
				.then((data) => {
					console.log(data)
					const countryArray = []
					const companyArray = []
					const scoresArray = []

					for (let entry of data) {
						if(entry.COO == null){
							countryArray.push("Undefined")
						}else{
							countryArray.push(entry.COO)
						}
						companyArray.push(entry.name)
						scoresArray.push(entry.csr ? entry.csr.score1 : 0)
					}

					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_END_LOADING,
						null,
						{ root: true }
					)

					this.updateAndPublishChart(countryArray, companyArray, scoresArray)
				})
				.catch((error) => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
	},
}
</script>

<style scoped>
.connection-map-card {
	overflow: visible;
}

.connection-map-frame {
	width: 100%;
	margin: 8px auto 12px;
}
</style>
